import { createRoute, redirect } from '@tanstack/react-router';
import { AppShell } from '@/components/layout/app-shell.js';
import { fetchCurrentUser } from '@/features/auth/api.js';
import { queryKeys } from '@/lib/query/keys.js';
import { rootRoute } from './root.js';

/**
 * Route pathless `_authenticated` : garde d'authentification unique pour tout
 * écran protégé (`02` — tous les écrans sauf §1). `beforeLoad` s'exécute à
 * chaque navigation vers une route fille ; `ensureQueryData` réutilise le
 * cache si `GET /auth/me` a déjà répondu récemment (`staleTime`), donc pas de
 * requête réseau à chaque clic dans la barre latérale.
 *
 * Toute erreur (401 compris) redirige vers `/connexion` avec l'URL demandée
 * dans `search.redirect`, pour y revenir après connexion (`login-form.tsx`).
 */
export const authenticatedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: '_authenticated',
  beforeLoad: async ({ context, location }) => {
    try {
      await context.queryClient.ensureQueryData({
        queryKey: queryKeys.auth.me(),
        queryFn: fetchCurrentUser,
        staleTime: 60_000,
      });
    } catch {
      // `redirect()` renvoie un `Response` (`Redirect extends Response` dans
      // `@tanstack/router-core`), pas une `Error` : c'est le mécanisme de
      // navigation officiel de TanStack Router, pas une erreur applicative.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/connexion', search: { redirect: location.href } });
    }
  },
  component: AppShell,
});
